import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "./components/ui/sonner";

// Context
import { AuthProvider } from "./context/AuthContext";
import { SettingsProvider } from "./context/SettingsContext";

// Layout
import Layout from "./components/Layout";
import AdminLayout from "./components/AdminLayout";

// Public Pages
import Home from "./pages/Home";
import Rules from "./pages/Rules";
import Join from "./pages/Join";
import Staff from "./pages/Staff";
import Status from "./pages/Status";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminPending from "./pages/admin/AdminPending";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminStaff from "./pages/admin/AdminStaff";
import AdminRules from "./pages/admin/AdminRules";
import AdminIncidents from "./pages/admin/AdminIncidents";
import AdminUsers from "./pages/admin/AdminUsers";

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
          <AnimatePresence mode="wait">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="rules" element={<Rules />} />
                <Route path="join" element={<Join />} />
                <Route path="staff" element={<Staff />} />
                <Route path="status" element={<Status />} />
              </Route>
              
              {/* Admin Auth Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/pending" element={<AdminPending />} />
              
              {/* Admin Protected Routes */}
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="staff" element={<AdminStaff />} />
                <Route path="rules" element={<AdminRules />} />
                <Route path="incidents" element={<AdminIncidents />} />
                <Route path="users" element={<AdminUsers />} />
              </Route>
            </Routes>
          </AnimatePresence>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
